import { Injectable } from "@angular/core";
import { AppInjector } from "@app/app.module";
import { HelpService } from "@app/services/help.service";
import { PlatformService } from "@app/services/platform.service";
import { ScriptService } from "@app/services/script.service";

@Injectable()

export class GenericComponent {

    public scriptService = AppInjector.get(ScriptService);
    public helpService = AppInjector.get(HelpService);
    public platformService = AppInjector.get(PlatformService);

    constructor() { }

    documentReady(): void {
        this.scriptService.documentReady();
    }
}
